import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUser } from '../Hooks';
import { Groupper, Header, Icon, Label, Placeholder, Stat, Table } from 'react-frontier';
import { addCommas } from '@payfront/components/Util';
import API from '../API';
import { Link } from 'react-router-dom';

interface WebhookData{
	webhook_id: number,
	webhook_url: string,
	live: boolean,
	last_status: number,
}

var WebhookList = ()=>{
	var { t } = useTranslation();
	var { active_client } = useUser();
	var [loadError, setLoadError] = useState<string>(null);
	var [webhooks, setWebhooks] = useState<WebhookData[]>(null);

	useEffect(()=>{
		API.getClientWebhooks(active_client).then(res=>{
			if(res.error) return setLoadError(res.message);
			setWebhooks(res.data);
		}).catch(err=>{
			setLoadError(t('common.unexpected_error', { code: 'WBHKL-1' }));
		});
	}, []);

	var webhook_status = useMemo(()=>{
		if(!webhooks) return false;
		for(var i of webhooks){
			if(i.last_status!==200){
				return false;
			}
		}
		return true;
	}, [webhooks]);

	if(loadError) return <Header text={t('common.error')} subtext={loadError} />
	
	return <div className="pf payout-list-screen webhook-list-screen" style={{ padding: 15 }}>
		<Stat.Group>
			<Stat value={(
				<Placeholder height={36} value={addCommas(webhooks?.length, false)} />
			)} label={t('common.webhooks')}></Stat>
			<Stat value={(
				<Placeholder height={36} value={webhooks ? (
					<Icon name={webhook_status ? 'check-circle' : 'triangle-exclamation'} style={{ marginRight: 0 }} color={webhook_status ? 'green' : 'brown'} />
				) : null} />
			)} label={t('common.status')}></Stat>
		</Stat.Group>
		<Groupper title={t('common.webhooks')}>
			<Table striped fitted
				className='last'
				collapsingIndexes={[0, 2, 3]}
				headers={['ID', t('common.url'), t('common.mode'), t('common.status')]}
			>
				{!webhooks ? <>
					<Table.Row
						collapsingIndexes={[0, 2, 3]}
						data={[
							<Placeholder width={10} />,
							<Placeholder />,
							<Placeholder width={40} />,
							<Placeholder width={15} />,
						]}
					/>
				</> : webhooks.length==0 ? (
					<Table.Cell empty row colSpan={4}>
						{t('webhooks.no_webhooks')}
					</Table.Cell>
				) : webhooks.map(a=>(
					<Table.Row selectable compact
						collapsingIndexes={[0, 2, 3]}
						as={Link}
						to={`/webhooks/${a.webhook_id}`}
						key={`WBHKL-${a.webhook_id}`}
						data={[
							a.webhook_id,
							a.webhook_url,
							<Label color={a.live ? 'green' : 'blue'}>{t(a.live ? 'common.live' : 'common.sandbox')}</Label>,
							<div style={{ color: a.last_status==200 ? 'green' : 'brown', fontWeight: 'bold' }}>
								<Icon name={a.last_status==200 ? 'check' : 'times'} />
								{a.last_status}
							</div>
						]}
					/>
				))}
			</Table>
		</Groupper>
	</div>
}

export default WebhookList;